{
  "pageTitle": "Endre vernet areal",
  "cardTitle": "Vernet areal",
  "cardDescription": "Endre vernet areal fordelt på høy, middels og lav bonitet",
  "cancelConfirm": {
    "title": "Er du sikker på at du vil avbryte?",
    "description": "Endringer du har gjort vil ikke bli lagret.",
    "continueEditing": "Fortsett redigering",
    "discardChanges": "Avbryt uten å lagre"
  },
  "emptyState": {
    "noRegisteredProperties": "Ingen eiendommer registrert"
  },
  "header": {
    "mainNumber": "Hovednummer"
  },
  "table": {
    "property": "Eiendom",
    "bonitetLevel": "Bonitetsnivå",
    "totalArea": "Areal (daa)",
    "protectedArea": "Vernet areal (daa)",
    "helpText": "Skriv inn hvor mange dekar av arealet i hvert bonitetsnivå som er vernet. Vernet areal kan ikke være større enn areal for samme bonitetsnivå",
    "productiveArea": "Produktivt areal (daa)",
    "total": "Totalt"
  },
  "bonitet": {
    "high": "Høy",
    "medium": "Middels",
    "low": "Lav"
  },
  "infoLabel": "Info"
}
